import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/LanguageContext';

const LanguageSelector = ({ className = '' }) => {
  const { language, changeLanguage } = useLanguage();
  const [showDropdown, setShowDropdown] = useState(false);

  const languages = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
    { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
    { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
    { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
    { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
    { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
    { code: 'ur', name: 'Urdu', nativeName: 'اردو' }
  ];

  const currentLang = languages.find(l => l.code === language) || languages[0];

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setShowDropdown(false);
  };

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        data-testid="language-selector-button"
        className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <Globe size={20} className="text-[#0F4C81]" />
        <span className="text-sm font-semibold text-[#111827]">{currentLang.nativeName}</span>
      </button>

      {showDropdown && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setShowDropdown(false)}
          />
          <div 
            className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border-2 border-slate-100 z-20 max-h-96 overflow-y-auto"
            data-testid="language-dropdown"
          >
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                data-testid={`language-option-${lang.code}`}
                className={`w-full text-left px-4 py-3 hover:bg-blue-50 transition-colors flex items-center justify-between ${
                  language === lang.code ? 'bg-blue-50 border-l-4 border-[#0F4C81]' : ''
                }`}
              >
                <div>
                  <p className="font-semibold text-[#111827]">{lang.nativeName}</p>
                  <p className="text-xs text-[#6B7280]">{lang.name}</p>
                </div>
                {language === lang.code && (
                  <div className="w-2 h-2 bg-[#0F4C81] rounded-full" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
